import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export const alertVariants = cva('flex w-full rounded-2xl border text-sm font-normal', {
  variants: {
    variant: {
      default: 'bg-muted text-text-secondary-600',
      info: 'border-dark-blue-200 bg-dark-blue-50 text-text-secondary-600 [&_svg]:text-dark-blue-700',
      error: 'border-red-100 bg-red-50/70 text-red-700 [&_svg]:text-red-700',
      warning: 'border-orange-200 bg-orange-50 text-text-secondary-600 [&_svg]:text-orange-700',
    },
    size: {
      s: 'gap-3 p-3 [&_svg]:size-4 [&_[data-slot=alert-description]]:text-xs',
      m: 'gap-4 p-4 [&_svg]:size-6 [&_[data-slot=alert-description]]:text-sm',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 's',
  },
});

export type AlertVariants = VariantProps<typeof alertVariants>;
